import { sharedApi } from "@/lib/api";

/**
 * Iter-263 jobs module — thin API layer.
 *
 * All endpoints under /api/classifieds/jobs unless noted. Every mutation
 * requires the user JWT via the standard sharedApi interceptor. Errors
 * bubble up as axios errors so callers can inspect status codes (409
 * incomplete-profile / duplicate, 415/413 upload limits, 400 own-listing).
 *
 * ⚠️ `file_url` on documents is a RELATIVE signed backend path — always
 * `originForFileUrl() + file_url` before opening.
 */
export function originForFileUrl() {
  return process.env.REACT_APP_BACKEND_URL || "";
}
export const resolveFileUrl = (relPath) =>
  relPath ? `${originForFileUrl()}${relPath}` : "";

// §1 profile
export const getJobProfile = () => sharedApi.get("/classifieds/jobs/profile").then((r) => r.data);
export const putJobProfile = (body) => sharedApi.put("/classifieds/jobs/profile", body).then((r) => r.data);

// §2 documents
export const listJobDocuments = () => sharedApi.get("/classifieds/jobs/documents").then((r) => r.data);
export const uploadJobDocument = (body) => sharedApi.post("/classifieds/jobs/documents", body).then((r) => r.data);
export const patchJobDocument = (id, body) => sharedApi.patch(`/classifieds/jobs/documents/${id}`, body).then((r) => r.data);
export const deleteJobDocument = (id) => sharedApi.delete(`/classifieds/jobs/documents/${id}`).then((r) => r.data);

// §3 apply-context
export const getApplyContext = (listingId) => sharedApi.get(`/classifieds/jobs/listings/${listingId}/apply-context`).then((r) => r.data);
// §4 screening questions
export const getListingQuestions = (listingId) => sharedApi.get(`/classifieds/jobs/listings/${listingId}/questions`).then((r) => r.data);
export const putListingQuestions = (listingId, body) => sharedApi.put(`/classifieds/jobs/listings/${listingId}/questions`, body).then((r) => r.data);
export const getQuestionBank = () => sharedApi.get("/classifieds/jobs/question-bank").then((r) => r.data);
// §5 submit
export const submitApplication = (listingId, body) => sharedApi.post(`/classifieds/jobs/listings/${listingId}/apply`, body).then((r) => r.data);

// §6 applicant tracking
export const myApplications = () => sharedApi.get("/classifieds/jobs/my/applications").then((r) => r.data);
export const getApplication = (id) => sharedApi.get(`/classifieds/jobs/applications/${id}`).then((r) => r.data);
export const withdrawApplication = (id) => sharedApi.post(`/classifieds/jobs/applications/${id}/withdraw`).then((r) => r.data);

// §7 employer
export const myJobListings = () => sharedApi.get("/classifieds/jobs/my/job-listings").then((r) => r.data);
export const listingApplications = (id, params = {}) => sharedApi.get(`/classifieds/jobs/listings/${id}/applications`, { params }).then((r) => r.data);
export const changeApplicationStatus = (body) => sharedApi.post("/classifieds/jobs/applications/status", body).then((r) => r.data);

// §9 notifications kinds handled here are surfaced through the shared
// NotificationBell — see /app/frontend/src/components/layout/NotificationBell.jsx.
export const mySavedJobs = () => sharedApi.get("/classifieds/jobs/my/saved").then((r) => r.data);
